const sections = {
  BasicDetails: {
    value: 'BASIC_DETAILS',
    label: 'insurancePolicy.form.columns.basicDetails'
  },
  ContributionsDetails: {
    value: 'CONTRIBUTIONS_DETAILS',
    label: 'insurancePolicy.form.columns.contributionsDetails'
  },
  AmountsDetails: {
    value: 'AMOUNTS_DETAILS',
    label: 'insurancePolicy.form.columns.amountsDetails'
  },
  Files: {
    value: 'FILES',
    label: 'insurancePolicy.form.columns.files'
  }
}
export default sections
